import { render, staticRenderFns } from "./PanelWithSessionEditor.vue?vue&type=template&id=87955aac&lang=pug&"
import script from "./PanelWithSessionEditor.vue?vue&type=script&lang=ts&"
export * from "./PanelWithSessionEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithSessionEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports